import nationality from "../../../src/assets/lesson_1_nationality/nationality.png";
import american from "../../../src/assets/lesson_1_nationality/american.png";
import english from "../../../src/assets/lesson_1_nationality/english.png";
import korea from "../../../src/assets/lesson_1_nationality/korea.png";
import france from "../../../src/assets/lesson_1_nationality/france.png";
import china from "../../../src/assets/lesson_1_nationality/china.png";
import japan from "../../../src/assets/lesson_1_nationality/japan.png";
import german from "../../../src/assets/lesson_1_nationality/german.png";
import russia from "../../../src/assets/lesson_1_nationality/russia.png";
import vietnam from "../../../src/assets/lesson_1_nationality/vietnam.png";
import nationalityaudio from "../../../src/assets/sounds/lesson_1_1/nationality.mp3"
import americanaudio from "../../../src/assets/sounds/lesson_1_1/american.mp3"
import englishaudio from "../../../src/assets/sounds/lesson_1_1/english.mp3"
import koreanaudio from "../../../src/assets/sounds/lesson_1_1/korean.mp3"
import frenchaudio from "../../../src/assets/sounds/lesson_1_1/french.mp3"
import chineseaudio from "../../../src/assets/sounds/lesson_1_1/chinese.mp3"
import japaneseaudio from "../../../src/assets/sounds/lesson_1_1/japanese.mp3"
import germanaudio from "../../../src/assets/sounds/lesson_1_1/german.mp3"
import russianaudio from "../../../src/assets/sounds/lesson_1_1/russian.mp3"
import vietnameseaudio from "../../../src/assets/sounds/lesson_1_1/vietnamese.mp3"
import hello from "../../../src/assets/lessons_1/hello.png";
import sorry  from "../../../src/assets/lessons_1/sorry.png";
import name from "../../../src/assets/lessons_1/name.png";
import tobe from "../../../src/assets/lessons_1/tobe.png";
import meet from "../../../src/assets/lessons_1/meet.png";
import happy from "../../../src/assets/lessons_1/happy.png";
import very from "../../../src/assets/lessons_1/very.png";
import we from "../../../src/assets/lessons_1/we.png";
import what from "../../../src/assets/lessons_1/what.png";
import your from "../../../src/assets/lessons_1/your.png";

import hi from "../../../src/assets/sounds/lesson_1/hi.mp3"
import sorryaudio from "../../../src/assets/sounds/lesson_1/sorry.mp3"
import nameaudio from "../../../src/assets/sounds/lesson_1/name.mp3"
import tobeaudio from "../../../src/assets/sounds/lesson_1/tobe.mp3"
import too from "../../../src/assets/sounds/lesson_1/too.mp3"
import veryaudio from "../../../src/assets/sounds/lesson_1/very.mp3"
import glad from "../../../src/assets/sounds/lesson_1/glad.mp3"
import gladmeetyou from "../../../src/assets/sounds/lesson_1/gladmeetyou.mp3"
import whatis from "../../../src/assets/sounds/lesson_1/whatis.mp3"
import youraudio from "../../../src/assets/sounds/lesson_1/your.mp3"

  export const unit_1=[
    {id:'0',english:'What is your nationality',vietnamese:'Người nước nào',audio:nationalityaudio,example:'Chị là người nước nào',picture:nationality},
    {id:'1',english:'American',vietnamese:'Người Mỹ',audio:americanaudio,example:'Tôi là người Mỹ',picture:american},
    {id:'2',english:'English',vietnamese:'Người Anh',audio:englishaudio,example:'Tôi là người Anh',picture:english},
    {id:'3',english:'Korean',vietnamese:'Người Hàn Quốc',audio:koreanaudio,example:'Tôi là người Hàn Quốc',picture:korea},
    {id:'4',english:'French',vietnamese:'Người Pháp',audio:frenchaudio,example:'Tôi là người Pháp',picture:france},
    {id:'5',english:'Chinese',vietnamese:'Người Trung Quốc',audio:chineseaudio,example:'Tôi là người Trung Quố',picture:china},
    {id:'6',english:'Japanese',vietnamese:'Người Nhật',audio:japaneseaudio,example:'Tôi là người Nhật',picture:japan},
    {id:'7',english:'German',vietnamese:'Người Đức',audio:germanaudio,example:'Tôi là người Đức',picture:german},
    {id:'8',english:'Russian',vietnamese:'Người Nga',audio:russianaudio,example:'Tôi là người Nga',picture:russia},
    {id:'9',english:'Vietnamese',vietnamese:'Người Việt Nam',audio:vietnameseaudio,example:'Tôi là người Việt Nam',picture:vietnam},
    {id:'10',english:'Hello, hi',vietnamese:'Xin chào',audio:hi,example:'Chào Anh!',picture:hello},
    {id:'11',english:'Sorry/ excuse me',vietnamese:'Xin lỗi/ xin mạn phép',audio:sorryaudio,example:'Xin lỗi anh tên là gì?',picture:sorry},
    {id:'12',english:'Name',vietnamese:'Tên',audio:nameaudio,example:'Tên tôi là David',picture:name},
    {id:'13',english:'To be(am/is/are)',vietnamese:'Là',audio:tobeaudio,example:'Tên em là Lính',picture:tobe},
    {id:'14',english:'Too',vietnamese:'Cũng',audio:too,example:'Cũng tôi (We)',picture:we},
    {id:'15',english:'Very',vietnamese:'Rất',audio:veryaudio,example:'Rất vui',picture:very},
    {id:'16',english:'Glad/nice/happy',vietnamese:'Vui',audio:glad,example:'Rất vui',picture:happy},
    {id:'17',english:'Glad to meet you',vietnamese:'Rất vui được gặp',audio:gladmeetyou,example:'Em cũng rất vui được gặp anh',picture:meet},
    {id:'18',english:'What is',vietnamese:'Là gì',audio:whatis,example:'Chủ Ngữ tên là gì?',picture:what},
    {id:'19',english:'Your',vietnamese:'Của bạn',audio:youraudio,example:'Em cũng rất vui được gặp anh',picture:your},
  ]